module.exports = __webpack_public_path__ + "56262ac0a527700ec9da374a5d6a9cc1.svg";